import React from 'react';
import Navbar from './global-components/navbar-v2';
import ErrorPage from './section-components/error';
import Footer from './global-components/footer';
import { Helmet } from 'react-helmet';

const Home_V1 = () => {
    return <div>
        <Helmet>
    <title>404 - Page Not Found | Muslim's Voice Network News</title>
    <meta name="description" content="Sorry, the page you're looking for doesn't exist. Explore other sections of Muslim's Voice Network News." />
    <meta name="keywords" content="404 error, page not found, Muslim news, explore sections" />
    <meta name="author" content="Muslim's Voice Network News" />
</Helmet>

        <Navbar />
        <ErrorPage />
        <Footer />
    </div>
}

export default Home_V1

